import { convertLegacyRouteRefs } from '@backstage/core-compat-api';
import {
  createComponentExtension,
  createPlugin,
  createRoutableExtension,
} from '@backstage/core-plugin-api';
import { CreateAppRouteBinder } from '@backstage/frontend-app-api';

import { ExternalRoutes, Routes, rootRouteRef } from './routes';

export const initiativesPlugin = createPlugin({
  id: 'initiatives',
  routes: {
    ...Routes,
  },
  externalRoutes: {
    ...ExternalRoutes,
  },
});

export const bindInitiativesRoutes = (
  bind: CreateAppRouteBinder,
  extraRoutes?: Parameters<typeof convertLegacyRouteRefs>[0],
) => {
  bind(
    convertLegacyRouteRefs(initiativesPlugin.externalRoutes),
    convertLegacyRouteRefs({
      ...initiativesPlugin.routes,
      ...extraRoutes,
    }),
  );
};

export const ConfidenceInitiativesPage = initiativesPlugin.provide(
  createRoutableExtension({
    name: 'ConfidenceInitiativesPage',
    component: () =>
      import(
        /* webpackChunkName: "confidence-initiatives", webpackPrefetch: 10 */ './Router'
      ).then(m => m.Router),
    mountPoint: rootRouteRef,
  }),
);

export const ConfidenceInitiativesExtension = initiativesPlugin.provide(
  createComponentExtension({
    name: 'ConfidenceInitiativesExtension',
    component: {
      lazy: () =>
        import(
          /* webpackChunkName: "confidence-initiatives-extension", webpackPrefetch: 10 */ './Router'
        ).then(m => m.Router),
    },
  }),
);
